export default "__VITE_ASSET__65cf5913__"